export class StaytimeAnalyticsRecord {
  toiletName?: string;
  data?: Array<number>;

  constructor(params?: Partial<StaytimeAnalyticsRecord>) {
    Object.assign(this, params);
  }
}

export class UsedRecord {
  timestamp?: number;
  value?: number;

  isEmpty(): boolean {
    return !this.timestamp || !this.value
  }

  raw(): [number, number] {
    return [this.timestamp || 0, this.value || 0]
  }

  constructor(params?: Partial<UsedRecord>) {
    Object.assign(this, params);
  }
}

export class UsedAnalyticsRecord {
  name?: string; // 'usedPersentage' とか入るっぽい。

  records?: Array<UsedRecord>;

  isEmpty(): boolean {
    return !this.records || this.records.length == 0
  }

  raw(): [number, number][] {
    return (this?.records || []).map(r => r.raw())
  }

  constructor(params?: Partial<UsedAnalyticsRecord>) {
    Object.assign(this, params);
  }
}

export class BoxUsedAnalyticsRecord {
  boxId?: string; // facility id と呼ばれるもの。個室のこと。
  series?: Array<UsedAnalyticsRecord>

  constructor(params?: Partial<BoxUsedAnalyticsRecord>) {
    Object.assign(this, params);
  }
}

export class CountRecord {
  label?: string;
  // assume receiving array of pair of unixtime and value
  data?: Array<number>;

  constructor(params?: Partial<CountRecord>) {
    Object.assign(this, params);
  }
}

export class CountAnalyticsRecord {
  labels?: Array<string>;
  datasets?: Array<CountRecord>;

  constructor(params?: Partial<CountAnalyticsRecord>) {
    Object.assign(this, params);
  }
}